<template>
  <div class="sort-pattern">
    <div class="fliter-div">
      <span>筛选：</span>
      <el-checkbox-group v-model="checkedFliters">
        <el-checkbox label="定制"></el-checkbox>
        <el-checkbox label="全书"></el-checkbox>
        <el-checkbox label="试读"></el-checkbox>
      </el-checkbox-group>
    </div>

    <div>
      <span>排序：</span>
      <el-select v-model="value" placeholder="" :collapse-tags="false">
        <el-option
          v-for="(item, index) in btnList"
          :key="item.lable"
          :label="item.lable"
          :value="item.lable"
        >
          <div @click="changeStatus(item, index)" class="sort-item">
            <span>{{ item.lable }}</span>
            <!-- 显示正向排序和反向排序 -->
            <div v-if="chooseIndex === index">
              <span v-if="item.status === 0">
                <img
                  class="sort-icon"
                  src="@/assets/images/icons/arrow-up.png"
                />
              </span>
              <span v-else>
                <img
                  class="sort-icon"
                  src="@/assets/images/icons/arrow-up(1).png"
                />
              </span>
            </div>
          </div>
        </el-option>
      </el-select>
    </div>
    <div>
      <span>模式:</span>
      <div class="model" @click="choosemodel('detail')">
        <img class="model-icon" :src="detailIcon" />
        <span v-if="this.modelType === 1" style="color:rgba(158, 92, 29, 1)"
          >详情</span
        >
        <span v-else style="color:rgba(99, 76, 55, 1)">详情</span>
      </div>
      <div class="model" @click="choosemodel('list')">
        <img class="model-icon" :src="listIcon" />
        <span v-if="this.modelType === 1">列表</span>
        <span v-else style="color:rgba(158, 92, 29, 1)">列表</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortPattern',
  props: {
    detailIcon: {
      default: ''
    },
    listIcon: {
      default: ''
    },
    modelType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      btnList: [
        { lable: '成书年', status: 0 },
        { lable: '著者', status: 0 },
        { lable: '书名', status: 0 },
        { lable: '分类', status: 0 },
        { lable: '热度', status: 0 },
        { lable: '收藏', status: 0 },
        { lable: '免费阅读', status: 0 }
      ],
      chooseIndex: -1,
      checkedFliters: [],
      value: ''
    }
  },
  methods: {
    changeStatus (item, index) {
      this.chooseIndex = index
      this.btnList[index].status === 0
        ? (this.btnList[index].status = 1)
        : (this.btnList[index].status = 0)
      this.$emit('changeStatus', this.btnList[index])
    },
    choosemodel (type) {
      this.$emit('choosemodel', type)
    }
  },
  watch: {
    checkedFliters (val) {
      console.log(val)
      this.$emit('changeCheckedFliter', val)
    }
  },
  mounted () {
    if (localStorage.getItem('customBook') === 'true' && !this.$route.query.bookId) {
      this.checkedFliters.push('定制')
      this.$emit('changeCheckedFliter', this.checkedFliters)
    }
  }
}
</script>

<style scoped>
.sort-pattern {
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  background: rgba(99, 76, 55, 0.07);
  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  margin-top: 2px;
  padding: 0px 20px;
}

ul,
li {
  margin: 0px;
  padding: 0px;
  display: flex;
}

li {
  list-style: none;
}

span {
  font-size: 16px;
}

.clicked-button {
  width: 78px;
  height: 26px;
  background: rgba(158, 92, 29, 1);
  margin-left: 5px;
  /* margin-top: 7px; */
  border-radius: 0px 0px 0px 0px;
  color: white;
}

.not-clicked {
  width: 78px;
  height: 26px;
  background: #634b371a;
  margin-left: 5px;
  /* margin-top: 7px; */
  border-radius: 0px 0px 0px 0px;
}

.not-clicked:hover {
  background-color: rgba(158, 92, 29, 0.5);
}

.sort-button {
  font-size: 14px;
  margin: auto;
}

.sort-icon {
  width: 8px;
  height: 11px;
  margin-left: 5px;
}

.active {
  background-color: #9e5c1d;
}

.model {
  display: inline;
  margin-right: 20px;
  cursor: pointer;
}

.model-icon {
  width: 12px;
  height: 12px;
}

.active-model {
  color: #9e5c1d;
}

.sort-pattern >>> .el-checkbox {
  margin-right: 10px;
}

.fliter-div {
  display: flex;
  align-items: center;
}

.sort-pattern >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #9e5c1d;
  background-color: #9e5c1d;
}

.sort-pattern >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9e5c1d;
}

.sort-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 30px;
  cursor: pointer;
  padding: 0px 10px;
}

.sort-pattern >>> .el-select {
  height: 30px;
}

.sort-pattern >>> .el-input {
  color: #634b37;
  width: 100px;
  border: 1px solid #634b37;
  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
}

.sort-pattern >>> .el-input__inner {
  border: #634b37;
  border-radius: 0px 0px 0px 0px;
  height: 30px;
}

.sort-pattern >>> .el-input__inner:focus {
  border: #634b37;
  border-radius: 0px 0px 0px 0px;
}

.sort-pattern >>> .el-select .el-input .el-select__caret {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sort-pattern >>> .el-icon-arrow-up::before {
  color: #634b37;
}
</style>



// WEBPACK FOOTER //
// src/components/SortPattern .vue